export var provinces = [{
    'abbreviation': 'AB',
    'name': 'Alberta'
}, {
    'abbreviation': 'BC',
    'name': 'British Columbia'
}, {
    'abbreviation': 'MB',
    'name': 'Manitoba'
}, {
    'abbreviation': 'NB',
    'name': 'New Brunswick'
}, {
    'abbreviation': 'NL',
    'name': 'Newfoundland and Labrador',
    'alt': ['Newfoundland', 'Labrador']
}, {
    'abbreviation': 'NS',
    'name': 'Nova Scotia'
}, {
    'abbreviation': 'NU',
    'name': 'Nunavut'
}, {
    'abbreviation': 'NT',
    'name': 'Northwest Territories'
}, {
    'abbreviation': 'ON',
    'name': 'Ontario'
}, {
    'abbreviation': 'PE',
    'name': 'Prince Edward Island'
}, {
    'abbreviation': 'QC',
    'name': 'Quebec'
}, {
    'abbreviation': 'SK',
    'name': 'Saskatchewan'
}, {
    'abbreviation': 'YT',
    'name': 'Yukon'
}];

export default provinces;



//////////////////
// WEBPACK FOOTER
// ./data/ca.provinces.js
// module id = 205
// module chunks = 0